import React, { createContext } from 'react';
import useCreateTheme, {
    ISideNavTheme,
    ISideNavThemeProps
} from './useCreateTheme';

export interface ISideNavContextProps {
    theme?: ISideNavThemeProps;
    supressPopovers?: boolean;
}

interface ISideNavContext {
    theme: ISideNavTheme;
    supressPopovers?: boolean;
}

if (!globalThis.SideNavContext) {
    globalThis.SideNavContext = createContext<ISideNavContext | undefined>(
        undefined
    );
}

export const SideNavContext =
    globalThis.SideNavContext as React.Context<ISideNavContext>;

export const useSideNavContext = (): ISideNavContext => {
    const context = React.useContext(SideNavContext);
    if (!context) {
        throw new Error(
            'useSideNavContext must be used within a SideNavProvider'
        );
    }
    return context;
};

export interface ISideNavProviderProps {
    context?: ISideNavContextProps;
    children: React.ReactNode;
}

const SideNavProvider: React.FC<ISideNavProviderProps> = ({
    children,
    context
}) => {
    const theme = useCreateTheme(context?.theme);

    const contextValue = {
        ...context,
        theme
    };

    return (
        <SideNavContext.Provider value={contextValue}>
            {children}
        </SideNavContext.Provider>
    );
};

export default SideNavProvider;
